import { render, staticRenderFns } from "./updateuser.vue?vue&type=template&id=5381f120&scoped=true&"
import script from "./updateuser.vue?vue&type=script&lang=js&"
export * from "./updateuser.vue?vue&type=script&lang=js&"
import style0 from "./updateuser.vue?vue&type=style&index=0&id=5381f120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381f120",
  null
  
)

export default component.exports